/**
 * Function to handle when prev/next icon is clicked
 * @param {component} iconType - prev/next
 * @param {number} currentPage - current page number
 * @param {function} setCurrentPage - function to set current page
 */
function whenPrevNextIconClicked(iconType, currentPage, setCurrentPage) {
	try {
		if (iconType !== 'prev' && iconType !== 'next') return null;

		let newPageNum = currentPage;

		if (iconType === 'prev') newPageNum = currentPage - 1;
		if (iconType === 'next') newPageNum = currentPage + 1;

		setCurrentPage(newPageNum);
		return newPageNum;
	} catch (e) {
		console.error(e);
		return null;
	}
}

export default whenPrevNextIconClicked;
